// The `expiry_in` URL filter and the dashboard's expiry buckets.
//
// The list page's own filter is cumulative ("60" = today .. day 60). The
// dashboard card counts disjoint buckets (today / 1-30 / 31-60 / 61-90), so
// its links carry an exact range ("31-60") and the rows shown equal the
// count that was clicked. The backend does the date maths for both.

import { documentExpiresInOptions } from "utils/constants";

const RANGE = /^(\d+)-(\d+)$/;

// Label for any expiry_in value: dropdown label, "31–60 days" for a range,
// otherwise the raw value so an unknown filter is still visible as a chip.
export const expiryInLabel = (value) => {
  const raw = value === null || value === undefined ? "" : String(value);
  if (!raw) return "";
  const option = documentExpiresInOptions.find((o) => String(o.value) === raw);
  if (option) return option.label;
  const match = raw.match(RANGE);
  return match ? `${match[1]}–${match[2]} days` : raw;
};

// One entry per row of the dashboard card, in display order. `key` is the
// field on the dashboard document-expiry payload.
export const DASHBOARD_EXPIRY_BUCKETS = [
  { key: "expiry_today", label: "Expiring Today", expiryIn: "today" },
  { key: "expiry_in_30_days", label: "Expiring in 30 Days", expiryIn: "1-30" },
  { key: "expiry_in_60_days", label: "Expiring in 60 Days", expiryIn: "31-60" },
  { key: "expiry_in_90_days", label: "Expiring in 90 Days", expiryIn: "61-90" },
];

// Where a dashboard bucket opens. The dashboard count skips terminated
// employees' documents, so the user list is narrowed the same way.
export const documentListPath = (type, expiryIn) => {
  const params = new URLSearchParams({ expiry_in: expiryIn });
  if (type === "store") return `/documents/store?${params}`;
  params.set("employee_status", "active");
  return `/documents?${params}`;
};
